import { render, staticRenderFns } from "./SpaceAttachStorageDialog.vue?vue&type=template&id=8a997fe0&"
import script from "./SpaceAttachStorageDialog.vue?vue&type=script&lang=js&"
export * from "./SpaceAttachStorageDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports